import { render, staticRenderFns } from "./ChipButton.vue?vue&type=template&id=12c61096&scoped=true"
import script from "./ChipButton.vue?vue&type=script&lang=js"
export * from "./ChipButton.vue?vue&type=script&lang=js"
import style0 from "./ChipButton.vue?vue&type=style&index=0&id=12c61096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c61096",
  null
  
)

export default component.exports